import PitchCall from "@/enums/PitchCall";
import CommonColorMapping from "./CommonColorMapping";
import colors from "./helpers/colors";

export default {
  [PitchCall.BallInPlay.key]: colors.blue.picton,

  [PitchCall.Ball.key]: colors.green.vidaLoca,
  [PitchCall.FoulBall.key]: colors.red.thunderbird,
  [PitchCall.CalledStrike.key]: colors.red.thunderbird,
  [PitchCall.SwingingStrike.key]: colors.red.thunderbird,
  [PitchCall.IntentionalBall.key]: colors.green.vidaLoca,

  [PitchCall.HitByPitch.key]: colors.grey.doveGray,
  [PitchCall.Unidentified.key]: colors.grey.doveGray,

  [PitchCall.ContactOut.key]: colors.black.almost,

  ...CommonColorMapping,
};
